import { Box, createStyles } from '@mantine/core';
import { Text } from '@repo/foundations';
import { memo } from 'react';
import type { QueriedResource } from '../types';
import { ResourceIcon } from './ResourceIcon';

const useStyles = createStyles((theme) => ({
	resourcePill: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: theme.spacing['4xs'],
		padding: `0 ${theme.spacing['2xs']}`,
		backgroundColor: theme.other.getColor('fill/secondary/default'),
		borderRadius: theme.radius.sm,
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		whiteSpace: 'nowrap',
		flexShrink: 0,
	},
}));

interface ResourcePillProps {
	resource: QueriedResource;
	maxNameLength?: number;
}

export const ResourcePill = memo(
	({ resource, maxNameLength = 30 }: ResourcePillProps) => {
		const { classes } = useStyles();
		const displayName =
			resource.name.length > maxNameLength
				? resource.name.substring(0, maxNameLength) + '...'
				: resource.name;

		return (
			<Box
				key={`${resource.type}-${resource.name}-${resource.integration_name || 'default'}`}
				className={classes.resourcePill}
			>
				<ResourceIcon resource={resource} />
				<Text size="xs" color="text/primary/default">
					{displayName}
				</Text>
			</Box>
		);
	}
);
